// extracted by mini-css-extract-plugin
export default {"root":"style_root__Wp2Km","ready":"style_ready__o8+WU","head":"style_head__bEJQS","names":"style_names__y+DRD"};